import certificateOperationPrint from '@/api/certificate-operation-print'
import MainProgram from '@/api/main-program'
import Year from '@/api/academic-year'
import SubProgram from '@/api/sub-program'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
    ...baseState,
}

export const getters = {}

export const mutations = {
    ...baseMutations,
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                search: context.state.search,
            },
            attrubutes
        )
        return certificateOperationPrint.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return certificateOperationPrint.store(data)
    },
    getMainProgram(context, attributes = {}) {
        return MainProgram.get({
            params: {
                fields: {
                    academic_program_mains: 'acp_id,acp_name_foreign'
                },
                page: -1
            },
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
    getSubProgram(context, attributes = {}) {
        return SubProgram.get({
            params: Object.assign(
                {
                    fields: {
                        academic_program_subs: 'acps_id,acps_name_foreign'
                    },
                    page: -1
                },
                attributes
            ),
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
    getYear(context, attributes = {}) {
        return Year.get({
            params: Object.assign(
                {
                    fields: {
                        academic_years: 'ac_year_id,ac_year,ac_status_id'
                    },
                    page: -1
                },
                attributes
            ),
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
    searchStudent(context, attributes = {}) {
        return certificateOperationPrint.studentCertificate({ params: attributes })
    },
    printPdf(context, id) {
        return certificateOperationPrint.printPdf({
            params: {
                ids: id
            }
        })
    }
}
